import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  ToastController,
  ViewController,
} from "ionic-angular";
import { IDGDataService } from "../../../providers/idg-data-service/idg-data-service";
import { StateManagementService } from "../../../providers/state-management/state-management.service";

/**
 * Generated class for the CreateVisitModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-create-comment-modal",
  templateUrl: "create-comment-modal.html",
})
export class CreateCommentModalPage {
  modalData: any = {};
  meetingId: any;
  validForm: boolean = false;
  idgUserId: any;
  patChartId: any;
  patient: any;
  commentInput: string = "";
  onSubmit: Function;
  submitting: boolean;
  patientData: any;
  onlineStatus: boolean = true;
  statusPoller: any;

  editIDGDiscussionNote = false;
  idgDiscussionCommentText = "";
  idgDiscussionComment = {};

  constructor(
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public stateData: StateManagementService,
    public idgSvc: IDGDataService,
    public toastCtrl: ToastController
  ) {
    this.modalData = this.navParams.data.modalData;
    this.meetingId = this.navParams.data.meetingId;
    this.onSubmit = this.navParams.data.onSubmit;
    this.idgUserId = this.navParams.data.idgUserId;
    this.patChartId = this.navParams.data.patChartId;
    this.patientData = this.navParams.data.patientData;

    this.createStatusPoller();

    this.editIDGDiscussionNote = this.navParams.data.editIDGDiscussionNote;
    this.idgDiscussionComment = this.navParams.data.idgDiscussionComment;
    if (this.idgDiscussionComment) {
      this.commentInput = this.idgDiscussionComment["text"];
      this.idgDiscussionCommentText = this.commentInput;
    }
  }

  createStatusPoller() {
    this.updateStatus();

    this.statusPoller = setInterval(() => {
      this.updateStatus();
    }, 500);
  }

  updateStatus() {
    let prevStatus = this.onlineStatus;
    this.onlineStatus = window.navigator.onLine;
    if (prevStatus && prevStatus !== this.onlineStatus)
      console.log("Internet Connection Lost");
  }

  submit() {
    //check if internet is out
    this.updateStatus();
    if (!this.onlineStatus) return;
    this.submitting = true;
    clearInterval(this.statusPoller);
    if (this.editIDGDiscussionNote) {
      const payload = {
        commentInput: this.commentInput,
        meetingId: this.meetingId,
        idgUserId: this.idgUserId,
        patChartId: this.patChartId,
        id: this.idgDiscussionComment["id"],
        createdDatetime: this.formatDateToISO(
          this.idgDiscussionComment["createdDatetime"]
        ),
      };
      this.viewCtrl.dismiss({ payload: payload, isEdit: true });
    } else {
      this.onSubmit(
        this.commentInput,
        this.meetingId,
        this.idgUserId,
        this.patChartId
      );
    }
  }

  onInput(comment) {
    this.commentInput = comment;
  }

  onDismiss() {
    clearInterval(this.statusPoller);
    this.viewCtrl.dismiss();
  }

  formatDateToISO(dateStr) {
    let date = new Date(dateStr.replace(/\//g, "-"));
    let yyyy = date.getFullYear();
    let mm = (date.getMonth() + 1).toString().padStart(2, "0");
    let dd = date.getDate().toString().padStart(2, "0");
    let hh = date.getHours().toString().padStart(2, "0");
    let min = date.getMinutes().toString().padStart(2, "0");
    let ss = date.getSeconds().toString().padStart(2, "0");
    let ms = date.getMilliseconds().toString().padStart(3, "0");
    return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}.${ms}`;
  }
}



// WEBPACK FOOTER //
// ./src/pages/inter-disciplinary-group/create-comment-modal/create-comment-modal.ts